export default __webpack_public_path__ + "static/chef-0afe0631ebe91f5dc410d6ca5bc8cc81.gif";